module.exports = __webpack_public_path__ + "teikeibun.no2.34c4c093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/teikeibun.no2.jpg
// module id = 7TZi
// module chunks = 0